import { forwardRef } from 'react';
import { StyledCheckbox } from './styles';
import type { CheckboxProps, CheckboxRef } from 'antd/es/checkbox';

export const Checkbox = forwardRef<CheckboxRef, CheckboxProps>(
    ({ name, disabled, ...props }, ref) => {
        return (
            <StyledCheckbox
                ref={ref}
                name={name}
                disabled={disabled}
                {...props}
            />
        );
    }
);
Checkbox.displayName = 'Checkbox';
